import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function Pedregalejo() {
  return <NeighborhoodPageContent slug="pedregalejo" />;
}